export const BRAND = {
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_loretas-kitchen-chat/artifacts/ijspkktq_2.png",
  character: "https://customer-assets-cm19k8pv.emergentagent.net/job_loretas-kitchen-chat/artifacts/0cqsn443_1.png",
  tagline: "Flavor You Trust",
};

export const QUICK_ACTIONS = [
  {
    id: "make",
    label: "What Should I Make",
    icon: "UtensilsCrossed",
    prompt: "I can't decide what to make. Ask me a couple quick questions, then suggest something delicious.",
  },
  {
    id: "have",
    label: "Cook With What I Have",
    icon: "Refrigerator",
    prompt: "Here's what I have on hand — help me cook something with these ingredients: ",
  },
  {
    id: "fix",
    label: "Fix My Food",
    icon: "Wrench",
    prompt: "My dish went wrong and I need help fixing it. Here's what happened: ",
  },
  {
    id: "plan",
    label: "Meal Planning",
    icon: "CalendarDays",
    prompt: "Help me plan meals for the week and give me a grocery list.",
  },
  {
    id: "sunday",
    label: "Sunday Dinner",
    icon: "Home",
    prompt: "Help me plan a cozy Sunday dinner the whole family will love.",
  },
  {
    id: "ask",
    label: "Ask Loretta",
    icon: "Heart",
    prompt: "Aunt Loretta, I need a little advice and some warmth today. ",
  },
];

export const RECIPE_IMAGES = {
  pasta: "https://images.unsplash.com/photo-1597131628347-c769fc631754?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  comfort: "https://images.unsplash.com/photo-1617474019977-0e105d1b430e?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  soup: "https://images.unsplash.com/photo-1516685018646-549198525c1b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  dessert: "https://images.unsplash.com/photo-1766186157159-3bcfa859b433?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  salad: "https://images.unsplash.com/photo-1473093226795-af9932fe5856?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  breakfast: "https://images.unsplash.com/photo-1735831829833-50a7d7c012a6?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  general: "https://images.unsplash.com/photo-1601932167327-8d25a0fb0752?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
};

export function recipeImage(category) {
  return RECIPE_IMAGES[category] || RECIPE_IMAGES.general;
}

// Parse assistant text: extract ```recipe {json}``` blocks, return {text, recipe}
export function parseRecipe(raw) {
  const match = raw.match(/```recipe\s*([\s\S]*?)```/);
  if (!match) return { text: raw, recipe: null };
  const text = raw.replace(match[0], "").trim();
  try {
    const recipe = JSON.parse(match[1].trim());
    return { text, recipe };
  } catch {
    return { text, recipe: null };
  }
}
